import { SET_ROLES_SEARCH_PARAMS } from 'src/actions/actionType'
import { INITIAL_ROLES_SEARCH_PARAMS } from 'src/views/security/roles/partials/Constants'

const initialState = {
  searchParams: INITIAL_ROLES_SEARCH_PARAMS,
}

export default function RolesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ROLES_SEARCH_PARAMS:
      return {
        ...state,
        searchParams: action.payload,
      }
    default:
      return state
  }
}
